import type { QueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/lib/queryKeys'
import type { DagTableLoadResponse } from '@/types/dag'

/**
 * Updates a single row's cells (and optionally its version) in all matching
 * DAG table query caches.
 */
export function updateDagRowInCache(
  queryClient: QueryClient,
  planId: string,
  versionId: string,
  rowId: string,
  cellUpdates: Record<string, unknown>,
  newVersion?: number
) {
  queryClient.setQueriesData<DagTableLoadResponse>(
    { queryKey: queryKeys.dagTable.rowsPrefix(planId, versionId) },
    old => {
      if (!old) return old
      return {
        ...old,
        rows: old.rows.map(row => {
          if (row.id === rowId) {
            return {
              ...row,
              ...(newVersion !== undefined && { row_version: newVersion }),
              cells: { ...row.cells, ...cellUpdates },
            }
          }
          if (row.parent_line_item?.id === rowId) {
            return {
              ...row,
              parent_line_item: {
                ...row.parent_line_item,
                ...('plan_sku_num' in cellUpdates && {
                  sku_number: cellUpdates.plan_sku_num as string | null,
                }),
                ...('description' in cellUpdates && {
                  description: cellUpdates.description as string | null,
                }),
              },
            }
          }
          return row
        }),
      }
    }
  )
}
